import { NavModel } from '@libs/shared/models';
import { createAction, props } from '@ngrx/store';

// eslint-disable-next-line @typescript-eslint/typedef
export const setMainNavigation = createAction(
  '[App] Set Main Navigation',
  props<{ mainNavigation: NavModel }>(),
);

// eslint-disable-next-line @typescript-eslint/typedef
export const loadMainNavigation = createAction('[App] Load Main Navigation');

// eslint-disable-next-line @typescript-eslint/typedef
export const loadMainNavigationSuccess = createAction(
  '[App] Load Main Navigation Success',
  props<{ mainNavData: NavModel }>(),
);

// eslint-disable-next-line @typescript-eslint/typedef
export const loadMainNavigationFailure = createAction(
  '[App] Load Main Navigation Failure',
  props<{ error: Error }>(),
);
